module.exports = {
  'firebase': 'ppa-development',
  'firebaseKey': 'AIzaSyC-E5nzag5XeQbxzmAgKNLt9eFVed34Dx4',
  'intercom': 'zdty3foh',
  'intercomToken': 'dG9rOjg0YWE1NTgzXzA2ZDhfNGNlNV85NDM4X2EyZWQzMGNkMGRkNzoxOjA=',
  'stripe': 'pk_test_mnubjLTPoYtw0RQHGwU0i3oy',
  'apiUrl': 'https://api.planetprotectoracademy.com:8080/'
};



// WEBPACK FOOTER //
// ./appConfig.js